module.exports = __webpack_public_path__ + "img/位图(1).4554eccc.png";